import { DimensionsModel } from './dimensions.model';

export class CoordinatesModel
    extends DimensionsModel {
    top?: number;
    right?: number;
    bottom?: number;
    left?: number;

    constructor(
        height: number,
        width: number,
        top: number = null,
        right: number = null,
        bottom: number = null,
        left: number = null
    ) {
        super(height, width);

        this.top = top;
        this.right = right;
        this.bottom = bottom;
        this.left = left;
    }
}
